import React from "react";
import { DayPickerProps as ReactDayPickerProps, DayPicker as ReactDayPicker } from "react-day-picker";
import { INavbarProps, Navbar } from "./Navbar";
import "./DayPicker.css";

type DayPickerProps = ReactDayPickerProps & {
  navbarProps?: Partial<INavbarProps>;
};

const MonthCaption = (monthCaptionProps: any, navbarProps?: Partial<INavbarProps>) => (
  <Navbar {...monthCaptionProps} {...navbarProps} />
);

export const DayPicker = (props: DayPickerProps) => {
  const { navbarProps, ...rest } = props;

  return (
    <ReactDayPicker
      components={{
        MonthCaption: (monthCaptionProps) => MonthCaption(monthCaptionProps, navbarProps),
      }}
      hideNavigation
      mode="single"
      {...rest}
    />
  );
};
